<template>
  <div id="login_sussceed_wrap">
    <headers/>
    <div class="login_sussceed_wrap_form">
      <div class="login_sussceed_wrap_form_img">
        <img src="../assets/comfirm.png" />
      </div>
      <div class="text_susses">提交成功</div>
      <div class="go_btn_wrap">
        <div class="go_btn" @click="go_back">返回个人中心</div>
      </div>
    </div>
    <footers/>
  </div>
</template>
<script>
import headers from "./header.vue";
import footers from "./footers.vue";
import Net_Work from "../apis/network.js";
export default {
  name: "backstage",
  components: { headers, footers },
  data() {
    return {};
  },
  methods: {
    go_back() {
      location.replace(Net_Work.publicPhoneAddress);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.login_sussceed_wrap_form {
  width: 100%;
  padding-bottom: 365px;
  .login_sussceed_wrap_form_img {
    margin-top: 240px;
    display: flex;
    justify-content: center;
    img {
      display: block;
    }
  }
  .text_susses {
    text-align: center;
    margin-top: 22px;
    font-size: 14px;
    letter-spacing: 2px;
    line-height: 18px;
  }
  .go_btn_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 45px;
    .go_btn {
      width: 260px;
      line-height: 30px;
      background-color: #3366ff;
      border: solid 1px #cccccc;
      text-align: center;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backstage_succeed.vue